import { useMemo, useState } from 'react';
import { useQuery } from 'react-query';
import { useNavigate } from 'react-router-dom';
import { backend } from '../axios/backend';
import DeleteModal from '../components/DeleteModal';
import PrettyLoader from '../components/PrettyLoader';
import ProductComponent from '../components/ProductComponent';
import Plus from '../components/icons/Plus';
import ShareSolid from '../components/icons/ShareSolid';
import Button from '../components/ui/Button';
import IconButton from '../components/ui/IconButton';
import Input from '../components/ui/Input';
import { useAppContext } from '../context/AppContext';
import { useDeleteProduct } from '../hooks/useDeleteProduct';
import { Product } from '../types/product';
import { Tag } from '../types/tag';

const MyWishesPage = () => {
  const navigate = useNavigate();
  const { user } = useAppContext();

  const [toDelete, setToDelete] = useState<Product | undefined>();

  // const tagsQuery = useTags();

  const [selectedTags] = useState<Record<string, Tag | undefined>>({});

  const query = useQuery(['my-wishes', user.username], async () => {
    const response = await backend.get<Product[]>('wish/my');
    return response.data;
  });

  const deleteMutation = useDeleteProduct(undefined, { onSuccess: () => setToDelete(undefined) });

  const filteredWishes = useMemo(() => {
    if (!query.data) return [];

    return query.data.filter((wish) => {
      const selectedTagsArray = Object.values(selectedTags).filter((t) => !!t);

      if (selectedTagsArray.length === 0) return true;

      return selectedTagsArray.every((t) => wish.tags?.some((wt) => wt === t?.name));
    });
  }, [query.data, selectedTags]);

  return (
    <div style={{ margin: '2rem' }}>
      <PrettyLoader useQueryResult={query}>
        <div className="space-y-2">
          <div className="flex flex-row justify-between items-center">
            <h1 className="text-white text-xl">
              <b>Meine Wünsche</b>
            </h1>
            <div className="space-x-2">
              <IconButton onClick={() => navigate('/share-wishes')} Icon={ShareSolid} />
              <IconButton onClick={() => navigate('/new-wish')} Icon={Plus} />
            </div>
          </div>
          <p className="text-white">Hier siehst du deine Wünsche.</p>
          {/* <Stack direction="row" spacing={1}>
          {tagsQuery.data && <TagToggles tags={tagsQuery.data} selected={selectedTags} setSelected={setSelectedTags} />}
          <IconButton onClick={() => navigate('/tags')} Icon={Pencil} />
        </Stack> */}

          <ul className="divide-y divide-gray-400 mb-4">
            {filteredWishes.map((wish) => (
              <ProductComponent
                key={wish.id}
                product={wish}
                onDelete={() => setToDelete(wish)}
                onClick={() => navigate(`/my-wish/${wish.id}`)}
                onEdit={(id) => navigate(`/edit-wish/${id}`)}
              />
            ))}
          </ul>

          <div className="flex flex-row space-x-4" >
            <Input name='wish' value='' onChange={() => { }} placeholder='Was wünscht du dir?' onClick={() => navigate("/new-wish")} />
            <Button onClick={() => navigate('/new-wish')} Icon={Plus}>
              Wunsch
            </Button>
          </div>
        </div>
      </PrettyLoader>

      <DeleteModal
        toDelete={toDelete}
        setToDelete={setToDelete}
        onDelete={() => toDelete && deleteMutation.mutate(toDelete.id)}
        isLoading={deleteMutation.isLoading}
        what={`deinen Wunsch (${toDelete?.name})`}
      />
    </div>
  );
};

export default MyWishesPage;
